var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.125h-3.277c.401-.426.652-.995.652-1.625A2.378 2.378 0 0 0 10.5.125c-1.092 0-2.012.893-2.5 2.224C7.512 1.018 6.592.125 5.5.125A2.378 2.378 0 0 0 3.125 2.5c0 .63.25 1.2.652 1.625H.5a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h.625V14.5c0 .758.617 1.375 1.375 1.375h11c.758 0 1.375-.617 1.375-1.375V7.875h.625a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375zm-5-3.25c.896 0 1.625.729 1.625 1.625s-.729 1.625-1.625 1.625H8.398C8.513 2.331 9.423.875 10.5.875zM3.875 2.5c0-.896.729-1.625 1.625-1.625 1.077 0 1.987 1.456 2.102 3.25H5.5A1.627 1.627 0 0 1 3.875 2.5zm10.25 12c0 .345-.28.625-.625.625h-11a.626.626 0 0 1-.625-.625V7.875H3.5a.375.375 0 0 0 0-.75H.875v-2.25h14.25v2.25H12.5a.375.375 0 0 0 0 .75h1.625z",
    fill: "#facb2f",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.208 8.67-1.984-.288-.888-1.798c-.125-.256-.547-.256-.672 0l-.888 1.798-1.984.289a.374.374 0 0 0-.208.64L6.02 10.71l-.338 1.977a.374.374 0 0 0 .544.395L8 12.149l1.774.933a.376.376 0 0 0 .544-.395L9.98 10.71l1.436-1.4a.374.374 0 0 0-.208-.64zm-1.893 1.64a.372.372 0 0 0-.107.333l.243 1.421-1.276-.67a.376.376 0 0 0-.35 0l-1.276.67.243-1.421a.372.372 0 0 0-.107-.332L5.65 9.304l1.428-.208a.374.374 0 0 0 .282-.205L8 7.598l.639 1.293c.054.111.16.188.282.205l1.428.208z",
    fill: "#facb2f",
    opacity: 1,
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/Bonus.55bdb3faf1c4ce5e3ac60db19e59d048.svg";
export { ForwardRef as ReactComponent };